const BASE_URL = import.meta.env.VITE_BASE_API_URL;

// Fail at boot rather than at the first request. Vite leaves an unset variable
// undefined, and a request built on it goes out relative to the page, or, in an
// embedded library, to another environment.
if (!BASE_URL) {
  const message = 'VITE_BASE_API_URL is not set; refusing to start without an API base URL.';

  // This runs while the module graph is still evaluating, before main.tsx mounts
  // its ErrorBoundary, so nothing downstream can render the failure. Paint it
  // into the app root so a misconfigured deploy is a message, not a blank page.
  if (typeof document !== 'undefined') {
    const root = document.getElementById(import.meta.env.VITE_APP_ROOT_ELEMENT_ID ?? 'root') ?? document.body;
    root.textContent = message;
  }

  throw new Error(message);
}

export const API_BASE_URLS = {
  BASE_URL,
} as const;
